var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkypeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "15px",
    height: "15px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.922 21.014c-.106-1.321-.616-2.223-1.089-2.794.161-.716.254-1.458.254-2.223 0-5.57-4.515-10.085-10.085-10.085-.765 0-1.507.093-2.223.254-.503-.439-1.908-1.416-4.251-1.086C6.542 5.5 4.792 8.417 5 11c.111 1.379.659 2.295 1.148 2.861a10.158 10.158 0 0 0-.231 2.136c0 5.57 4.515 10.086 10.085 10.086.736 0 1.452-.084 2.143-.233.506.44 1.91 1.413 4.249 1.084 2.985-.42 4.736-3.336 4.528-5.92zm-5.938-.248c-.69.774-1.604 1.548-3.797 1.828-3.672.469-5.781-1.312-6.344-1.859s-.656-1.911-.031-2.406c.828-.656 1.512-.545 2.781.75 1.562 1.594 4.093 1.163 4.516.281.359-.75-.078-1.328-.891-1.562-.859-.248-4.05-1.047-4.609-1.266-2.873-1.123-2.219-3.859-2.094-4.297s.456-2.329 4.047-2.891c3.592-.562 5.812 1.188 5.812 1.188 1.312 1.047.797 2.406.078 2.781s-1.328.25-2.312-.656-2.312-.797-2.625-.766-1.281.109-1.515.768.172 1.043.922 1.341c1.469.583 3.362.316 5.484 1.75 2.266 1.531 1.219 4.297.578 5.016z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkypeIcon);
export default __webpack_public_path__ + "static/media/skypeIcon.ad51cbb5792c5c216917c003699a8328.svg";
export { ForwardRef as ReactComponent };